<script setup lang="ts">
  import AddressForm from '@/components/AddressForm.vue'
  import { FormInput } from '@logistiek-zonder-papier/lzp-library'
  import type { Organization } from '@/types/organization'
  import FormHeading from '@/components/form/FormHeading.vue'
  import { getAddressFromOrganization } from '@/utils/organization'

  defineProps<{
    carriers: Organization[]
    removeCarrier: (id: string) => void
  }>()
</script>

<template>
  <div v-for="(carrier, index) in carriers" :key="carrier.id" class="organization-container">
    <FormHeading
      :label="`Vervoerder ${index + 1}`"
      @click="removeCarrier(carrier.id.toString())"
      class="override-header"
    />
    <div class="organization-content">
      <FormInput :model-value="carrier.organisatieNaam" label="Organisatienaam" disabled />
      <AddressForm :address="getAddressFromOrganization(carrier)" />
      <FormInput :model-value="carrier.organisatieNummer" label="Organisatienummer" disabled />
    </div>
  </div>
</template>

<style scoped>
  .override-header {
    margin: var(--components-media-corners);
  }

  .organization-container {
    border: 0.06rem solid var(--colours-grey-3);
    margin-bottom: 1rem;
    border-radius: 0.25rem;
  }

  .organization-content {
    padding: var(--spacing-s);
  }

  .remove-btn {
    margin: 0.625rem;
    justify-self: right;
  }
</style>
